<template>
  <v-container fluid>
    <v-layout>
      <v-flex 
        xs12 
        md8
        lg6
        offset-md2
        offset-lg3>
        <v-card 
          flat
          class="card-event">
          <v-toolbar
            color="rgba(230, 27, 88, 0.9)"
            dark>
            <v-toolbar-side-icon>
              <v-icon 
                medium 
                @click="$router.go(-1)">
                fas fa-chevron-left
              </v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title>{{ event.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-flex 
              class="text-xs-right">
              <component 
                :is="isMobile ? 'MobileCardMenu' : 'DesktopCardMenu'" 
                :menu-items="menuItems"
                :menucolor="'grey lighten-3'"></component>
            </v-flex>
          </v-toolbar>
          <v-btn 
            id="eventSign"
            style="margin: 155px 0  0 -12px; height: 30px; width: 30px;"
            absolute
            depressed
            fab
            small
            dark 
            color="pink lighten-1">
            <v-icon>fas fa-star</v-icon>
          </v-btn>
          
          <v-img
            :src="event.imgUrl"
            class="white--text"
            height="170px">
          </v-img>
          <v-card-text 
            class="card-info">
            <v-layout 
              align-end
              row 
              wrap>
              <v-flex 
                xs12
                md8>
                <v-flex>
                  <!-- <span
              class="font-weight-light" 
              style="color: #424242">          
              MO, 24. SEP UM 20:00</span> -->
                  <span
                    class="font-weight-light" 
                    style="color: #424242">          
                    {{ event.date }} UM {{ event.time }}
                  </span>
                </v-flex>


                <v-flex>
                  <span class="headline">
                    {{ event.title }}
                  </span>
                </v-flex>

                <v-flex>
                  <span>
                    <v-icon 
                      small>
                      fas fa-map-marker
                    </v-icon>
                    {{ event.location }}
                  </span>
                </v-flex>
              </v-flex>

              <v-flex 
                xs12
                md4
                class="text-md-right">
                <v-chip 
                  style="width: 100px"
                  label 
                  disabled
                  small
                  color="pink" 
                  text-color="white">
                  <v-icon 
                    left 
                    dark>
                    fas fa-music
                  </v-icon>Music
                </v-chip>
                <v-chip 
                  style="width: 100px"

                  label 
                  disabled
                  small
                  color="orange" 
                  text-color="white">
                  <v-icon 
                    left 
                    dark>
                    fas fa-account-group
                  </v-icon>Meetup
                </v-chip>
              </v-flex>
            </v-layout>


      
            <v-layout 
              mt-2  
              row 
              fill-height>
              <v-flex xs12>
                <v-img 
                  :src="require('@/assets/map.png')"  
                  class="roundedcard"
                  height="125">
                </v-img>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text>
            {{ event.content }}
          </v-card-text>
  



          <v-divider light></v-divider>

          <v-card-actions>
            <v-layout>
              <v-flex 
                ml-3
                style="flex: 0 0 auto"
                d-inline-flex
                align-center>
                <v-img 
                  :src="event.imgUrl"
                  class="card-participants">
                </v-img>
                <v-img 
                  :src="event.imgUrl"
                  class="card-participants">
                </v-img>
                <v-img 
                  :src="event.imgUrl"
                  class="card-participants">
                </v-img>
        
                <article 
                  class="caption" 
          
                  style="color: grey;">
                  +34
                </article>
              </v-flex>
              <v-spacer></v-spacer>
      
              <v-flex>
                <v-btn 
                  :icon="isMobile"
                  small
                  color="pink lighten-1" 
                  flat>
                  <v-icon dark>
                    fas fa-check
                  </v-icon>
                </v-btn>
              </v-flex>

              <v-flex>
                <v-btn 
                  :icon="isMobile"
                  flat
                  small
                  color="pink lighten-1">
                  <v-icon 
                    dark>
                    fas fa-heart-outline
                  </v-icon>
                </v-btn>
              </v-flex>

              <v-flex>
                <v-btn 
                  :icon="isMobile"
                  color="pink lighten-1" 
                  small
                  flat>
                  <v-icon 
                    dark>
                    fas fa-share-outline
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
   


    <v-layout 
      class="mt-3" 
      row> 
      <v-flex 
        xs12 
        md8
        lg6
        offset-md2
        offset-lg3>
        <v-card class="pb-2">
          <template v-for="(item, index) in items">
            <v-layout 
              :key="item.title"
              class="pt-2"
              justify-center>
              <v-flex 
                class="mt-1 text-xs-center"
                style="width: 72px; min-width: 72px; max-width: 72px;">
                <v-avatar size="36px">
                  <img :src="item.avatar">
                </v-avatar>
              </v-flex>
              <v-layout 
                column>
                <v-flex 
                  xs12>
                  <div class="subheading">
                    {{ item.title }}
                  </div>
                  <div class="grey--text text--darken-1">
                    {{ item.subtitle }}
                  </div>
                </v-flex>

                <v-flex 
                  xs12>
                  <div 
                    style="cursor: pointer" 
                    class="caption grey--text">
                    &bull; Antworten
                  </div>
                </v-flex>
              </v-layout>
              <v-flex style="width: 72px; min-width: 72px; max-width: 72px;">
                <div class="caption pr-2 text-xs-right grey--text">
                  {{ item.action }}
                </div>
              </v-flex>
            </v-layout>



            <template v-if="item.answer">
              <v-layout 
                v-for="itema in item.answer"
                :key="itema.answer"
                class="pt-2"
                justify-center>
                <v-flex 
                  class="mt-1 pr-3 text-xs-right"
                  style="width: 90px; min-width: 90px; max-width: 90px;">
                  <v-avatar size="30px">
                    <img :src="itema.avatar">
                  </v-avatar>
                </v-flex>
             
                <v-flex 
                  xs12>
                  <div class="subheading">
                    {{ item.title }}
                  </div>
                  <div class="grey--text text--darken-1">
                    {{ itema.subtitle }}
                  </div>
                </v-flex>

                
                <v-flex style="width: 72px; min-width: 72px; max-width: 72px;">
                  <div class="caption pr-2 text-xs-right grey--text">
                    {{ itema.action }}
                  </div>
                </v-flex>
              </v-layout>
            </template>


            <v-divider
              v-if="index + 1 < items.length"
              :key="index"
              class="mt-1"
              inset></v-divider>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DesktopCardMenu  from '@/components/global_comps/Cards/Desktop_CardMenu'
import MobileCardMenu   from '@/components/global_comps/Cards/Mobile_CardMenu'

export default {
  components: {
    // eslint-disable-next-line
    DesktopCardMenu,
    // eslint-disable-next-line
    MobileCardMenu
  },
  props: {
    id: { type: String, required: true }
  },
  data() {
    return {
      selected: [
        2
      ],
      items: [
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          action: '15 min',
          title: 'Ali Connors',
          subtitle:
            'I\'ll be in your neighborhood doing errands this weekend. Do you want to hang out? I\'ll be in your neighborhood doing errands this weekend. Do you want to hang out?',
          answer: {
            id001: {
              avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
              action: '4 min',
              title: 'Alid Con',
              subtitle: 'Yeah thats funny!'
            },
            id002: {
              avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
              action: '1 min',
              title: 'Alonnors Bubb',
              subtitle: 'Never ever going to go there'
            }
          }
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
          action: '2 hr',
          title: 'Scrott Jennifer',
          subtitle: 'Wish I could come, but I\'m out of town this weekend.'
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
          action: '6 hr',
          title: 'Sandra Adams',
          subtitle: 'Do you have Paris recommendations? Have you ever been?',
          answer: {
            id001: {
              avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
              action: '4 min',
              title: 'Alid Con',
              subtitle: 'Yeah thats funny!'
            },
            id002: {
              avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
              action: '1 min',
              title: 'Alonnors Bubb',
              subtitle: 'Never ever going to go there'
            },
            id003: {
              avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
              action: '1 min',
              title: 'Alonnors Bubb',
              subtitle: 'No no no no no no no'
            }
          }
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
          action: '12 hr',
          title: 'Trevor Hansen',
          subtitle:
            'Have any ideas about what we should get Heidi for her birthday?',
          answer: {
            id001: {
              avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
              action: '4 min',
              title: 'Alid Con',
              subtitle: 'Yeah thats funny!'
            }
          }
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          action: '18hr',
          title: 'Britta Holt',
          subtitle:
            'We should eat this: Grate, Squash, Corn, and tomatillo Tacos.'
        }
      ],

      menuItems: [
        { icon: 'fas fa-pencil', title: 'Bearbeiten' },
        { icon: 'fas fa-delete-forever', title: 'Löschen' },
        { icon: 'fas fa-alert', title: 'Aktivität Melden' },
        { icon: 'fas fa-eye-off-outline', title: 'Ausblenden' },
        { icon: 'fas fa-eye-off', title: 'User nicht mehr anzeigen' }
      ]
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile
    }),
    ...mapGetters({
      posts: 'getPosts'
    }),
    event() {
      return this.$store.getters.getEvent(this.$route.params.id)
    }
  },
  methods: {
    toggle(index) {
      const i = this.selected.indexOf(index)

      if (i > -1) {
        this.selected.splice(i, 1)
      } else {
        this.selected.push(index)
      }
    }
  }
}
</script>




<style lang="scss" scoped>
.card-event {
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(230, 27, 88, 0.4);
  border-radius: 16px;
  filter: drop-shadow(2px 2px 5px rgba(230, 27, 88, 0.4));
}

.card-avatar {
  border-radius: 50%;
  height: 48px;
  width: 48px;
}

.card-participants {
  border-radius: 50%;
  border: 2px solid white;
  height: 26px;
  width: 26px;
  max-height: 26px;
  max-width: 26px;
  margin-left: -8px;
}

.card-info {
  background-color: rgba(230, 27, 88, 0.05);
}

#eventSign {
  z-index: 5;
  border: 3px solid white;
  background-image: linear-gradient(330deg, #d81b60, #eeff41);
}
</style>
